import { getDPI } from '@/utils/unit-kit';
import type { RulerUnit } from './types';

/** RulerBar 实例内部使用的显示状态事件。 */
export enum RULER_BAR_EVENTS {
    /** 标尺显示状态变化。 */
    ON_SHOW_CHANGED = 'show-ruler-bar-changed-event',
}

/** localStorage 中按编辑器实例保存标尺显示状态的 key 前缀。 */
export const SHOW_RULER_BAR_STORAGE_KEY = 'show-editor-ruler-bar__';

/** 标尺的固定宽高：水平标尺高度与垂直标尺宽度，单位为 CSS 像素。 */
export const RULER_BAR_SIZE = 24;

/** 刻度相对标尺边缘的偏移量。 */
export const SHORT_TICK_OFFSET = 17;
/** 短刻度线长度。 */
export const SHORT_TICK_SIZE = 6;
/** 刻度文字相对标尺边缘的偏移量。 */
export const TEXT_OFFSET = 15;
/** 刻度文字字号；当前绘制逻辑尚未设置字体，暂不生效。 */
export const FONT_SIZE = '12px';
/** 刻度文字与最后一个刻度之间的最小间距。 */
export const MIN_LAST_GAP = 25;
/** 标尺支持切换的单位列表。 */
export const RULER_UNIT_LIST: RulerUnit[] = ['px', 'cm', 'mm'];

/** 获取标尺刻度间距 */
export function getTickGap(scale: number, unit: RulerUnit) {
    let gap = 50;

    if (unit === 'px') {
        if (scale <= 0.04) {
            gap = 2500;
        } else if (scale <= 0.1) {
            gap = 1000;
        } else if (scale <= 0.2) {
            gap = 500;
        } else if (scale <= 0.4) {
            gap = 250;
        } else if (scale <= 1) {
            gap = 100;
        } else if (scale <= 2) {
            gap = 50;
        } else if (scale <= 4) {
            gap = 25;
        } else {
            gap = 10;
        }
    }

    if (unit === 'cm') {
        if (scale <= 0.1) {
            gap = 10;
        } else if (scale <= 0.4) {
            gap = 5;
        } else if (scale <= 1) {
            gap = 2;
        } else {
            gap = 1;
        }
    }

    if (unit === 'mm') {
        if (scale <= 0.1) {
            gap = 100;
        } else if (scale <= 0.4) {
            gap = 50;
        } else if (scale <= 1) {
            gap = 20;
        } else if (scale <= 2) {
            gap = 10;
        } else {
            gap = 5;
        }
    }

    return gap;
}

/** 获取像素尺寸与物理尺寸之间的换算比例 */
export function getPhysicalRatio(unit: RulerUnit) {
    const dpi = getDPI();
    if (unit === 'cm') return (1 / dpi) * 2.54;
    if (unit === 'mm') return (1 / dpi) * 25.4;
    return 1;
}
